import React from "react";
import { Grid, GridProps } from "@mui/material";
import { cn } from "../../../helpers/cn";

type BlogChipsWrapperProps = GridProps;

export const BlogChipsWrapper = ({
  className,
  children,
}: BlogChipsWrapperProps) => {
  return (
    <Grid spacing={1} container className={cn("mt-4", className)}>
      {children}
    </Grid>
  );
};
